module.exports = __webpack_public_path__ + "img/efset-score02.8910e789.jpg";